module.exports = __webpack_public_path__ + "img/hlb.e8bcb6c3.jpg";